import { render, staticRenderFns } from "./Cascader.vue?vue&type=template&id=f12c7e00&"
import script from "./Cascader.vue?vue&type=script&lang=js&"
export * from "./Cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports